import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {AppRoutingMudule} from './app-routing.mudule';
import {HomeComponent} from './home/home.component';
import {CommonService} from './services/common.service';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {AgmCoreModule} from '@agm/core';
import {ContactComponent} from './contact/contact.component';
import { CapitalsComponent } from './capitals/capitals.component';
import { PhilanthropyComponent } from './philanthropy/philanthropy.component';
import { NewsComponent } from './news/news.component';
import { TeamComponent } from './team/team.component';
import { MissionComponent } from './mission/mission.component';
import { SaurabhMittalComponent } from './team/saurabh-mittal/saurabh-mittal.component';
import { LeadershipComponent } from './team/leadership/leadership.component';
import { InvestmentTeamComponent } from './team/investment-team/investment-team.component';
import { PlatformServicesComponent } from './capitals/platform-services/platform-services.component';
import { MediaComponent } from './capitals/media/media.component';
import { FintechComponent } from './capitals/fintech/fintech.component';
import { AssetComponent } from './capitals/asset/asset.component';
import { MissionCapitalComponent } from './mission-capital/mission-capital.component';
import { CapitalDetailsComponent } from './mission-capital/capital-details/capital-details.component';
import { LookingForComponent } from './mission-capital/looking-for/looking-for.component';
import { CapitalInvestmentComponent } from './mission-capital/capital-investment/capital-investment.component';
import { environment } from './../environments/environment';

@NgModule({
   declarations: [
      AppComponent,
      HomeComponent,
      ContactComponent,
      CapitalsComponent,
      PhilanthropyComponent,
      NewsComponent,
      TeamComponent,
      MissionComponent,
      SaurabhMittalComponent,
      LeadershipComponent,
      InvestmentTeamComponent,
      PlatformServicesComponent,
      MediaComponent,
      FintechComponent,
      AssetComponent,
      MissionCapitalComponent,
      CapitalDetailsComponent,
      LookingForComponent,
      CapitalInvestmentComponent
   ],
   imports: [
      BrowserModule,
      AppRoutingMudule,
      SlickCarouselModule
   ],
   providers: [
      CommonService
   ],
   bootstrap: [AppComponent]
})
export class AppModule {
}
